import React from 'react'

import { Image } from '@domain-group/suit-theme'

import type { TemplatePageModel } from '@domain-group/realhub-backend-api-types'

export type TemplatePagePreviewRenderParams = {
  height: number | string,
  templatePage: Partial<TemplatePageModel>,
  width: number | string,
}

interface TemplatePagePreviewProps {
  boxProps?: Record<string, unknown>,
  children?: React.ReactNode | ((params: TemplatePagePreviewRenderParams) => React.ReactNode),
  height: number | string,
  templatePage: Partial<TemplatePageModel>,
  width: number | string,
}

const PreviewImage = (props: TemplatePagePreviewProps) => {
  const {
    templatePage,
    boxProps,
    children,
    height,
    width,
  } = props

  const imageUrl = templatePage?.preview_image

  return (
    <Image
      backgroundPosition="center"
      backgroundSize="contain"
      height={height}
      url={imageUrl || undefined}
      width={width}
      {...boxProps}
    >
      {typeof children === 'function'
        ? children({
          height,
          templatePage,
          width,
        })
        : children}
    </Image>
  )
}

export default PreviewImage
